import React, { useState, useEffect } from 'react'
import { Layout, Flex, Select, Pagination } from 'antd';
import MyHeaderOne from '../header';
import MyFooter from '../footer';
import style from './page.module.less'
import axios from 'axios';
import { REQUEST_URL } from '../../utils/env';

const { Header, Footer, Content } = Layout;

export default function Qqrd() {

    const [searchInfo, setSearchInfo] = useState({ 'desc': null, 'offset': 0 })
    const [total, setTotal] = useState(0)

    const [rdzz, setRdzz] = useState()
    const getRDZZ = async () => {
        try {
            const { data } = await axios.get(
                REQUEST_URL + '/info/getRDZZ',
                { params: searchInfo }
            )
            setRdzz(data)
            setTotal(data.total)
        } catch (error) {
            throw new Error(error)
        }
    }

    const onPaginationChange = (pagination, filters, sorter, extra) => {
        setSearchInfo({ ...searchInfo, 'offset': (pagination - 1) * filters })
    };


    const descChange = (value) => {
        setSearchInfo({ ...searchInfo, desc: value })
    }

    useEffect(() => {
        getRDZZ()
    }, [searchInfo])

    return (
        <Layout className={style.kycg}>
            <Header className={style.kycg__header}>
                <MyHeaderOne />
            </Header>
            <Content className={style.kycg__wapper}>
                <Flex vertical={true} className={style.kycg__wapper__one} align='center'>
                    <Flex className={style.kycg__wapper__one__title}>全球热点追踪</Flex>
                    <Flex className={style.kycg__wapper__one__info}>监测分析国内外科技期刊出版的发展态势，准确研判世界一流科技期刊的前沿动向、有效服务于我院的科技期刊战略团队、科技期刊管理部门、以及我院的科技期刊团队</Flex>
                </Flex>
                <Flex vertical={false} align='start' className={style.kycg__wapper__two}>
                    <Flex vertical={true} className={style.kycg__wapper__two__left}>
                        <Flex justify='space-between' className={style.kycg__wapper__two__left__title} >
                            <Flex className={style.kycg__wapper__two__left__title__left}>
                                全球热点追踪（共{total}篇）
                            </Flex>
                            <Flex className={style.kycg__wapper__two__left__title__right} align='center'>
                                <Select defaultValue="时间排序" style={{ width: 100, height: 24 }}
                                    onChange={(value) => descChange(value)}
                                    options={[{ value: '时间排序', label: '时间排序', },
                                    { value: 'ASC', label: '升序', },
                                    { value: 'DESC', label: '降序', },]}
                                />
                            </Flex>
                        </Flex>

                        {(rdzz !== undefined) && rdzz.data.map((item, index) => {
                            return (
                                <Flex key={index} vertical={true} className={style.kycg__wapper__two__left__item}>
                                    <Flex className={style.kycg__wapper__two__left__item__title}><a target='_blank' href={(item.isUp === '是') ? `./detail?show=xxfb&id=${item.id}` : item.url}>{item.title}</a></Flex>
                                    <Flex className={style.kycg__wapper__two__left__item__info}>{item.info}</Flex>
                                    <Flex className={style.kycg__wapper__two__left__item__date_editor}>{item.pub_date} | {item.author}</Flex>
                                </Flex>
                            )
                        })}

                        <Flex className={style.kycg__wapper__two__left__pag} justify='center' align='center'>
                            <Pagination onChange={onPaginationChange} align="center" defaultCurrent={1} showSizeChanger={false} pageSize={20} total={total} />
                        </Flex>
                    </Flex>
                    <Flex vertical={true} className={style.kycg__wapper__two__right}>
                        <Flex className={style.kycg__wapper__two__right__title}>热门文章</Flex>
                        <Flex vertical={true} className={style.kycg__wapper__two__right__items}>
                            <Flex vertical={true} className={style.kycg__wapper__two__right__item}>
                                <Flex className={style.kycg__wapper__two__right__item__title}>
                                    <a>改变开放知识的获取方式，促进全球可持续发展目标的实现</a>
                                </Flex>
                                <Flex className={style.kycg__wapper__two__right__item__date_editor}>
                                    2023-11-22  |  张菲菲
                                </Flex>
                            </Flex>
                            <Flex vertical={true} className={style.kycg__wapper__two__right__item}>
                                <Flex className={style.kycg__wapper__two__right__item__title}>
                                    <a>UPLOpen.com：改变开放知识的获取方式，促进全球可持续发展目标的实现</a>
                                </Flex>
                                <Flex className={style.kycg__wapper__two__right__item__date_editor}>
                                    2023-11-22  |  张菲菲
                                </Flex>
                            </Flex>
                            <Flex vertical={true} className={style.kycg__wapper__two__right__item}>
                                <Flex className={style.kycg__wapper__two__right__item__title}>
                                    <a>PLOS发布2018-2023开放科学指标数据</a>
                                </Flex>
                                <Flex className={style.kycg__wapper__two__right__item__date_editor}>
                                    2023-11-22  |  张菲菲
                                </Flex>
                            </Flex>
                            <Flex vertical={true} className={style.kycg__wapper__two__right__item}>
                                <Flex className={style.kycg__wapper__two__right__item__title}>
                                    <a>改变开放知识的获取方式，促进全球可持续发展目标的实现</a>
                                </Flex>
                                <Flex className={style.kycg__wapper__two__right__item__date_editor}>
                                    2023-11-22  |  张菲菲
                                </Flex>
                            </Flex>
                            <Flex vertical={true} className={style.kycg__wapper__two__right__item}>
                                <Flex className={style.kycg__wapper__two__right__item__title}>
                                    <a>PLOS发布2018-2023开放科学指标数据</a>
                                </Flex>
                                <Flex className={style.kycg__wapper__two__right__item__date_editor}>
                                    2023-11-22  |  张菲菲
                                </Flex>
                            </Flex>
                        </Flex>
                    </Flex>
                </Flex>
            </Content>
            <Footer className={style.kycg__footer}>
                <MyFooter />
            </Footer>
        </Layout >
    )
}
